import "../styles/loading.css";

export const ComponentLoadingSpinner = ({message, size = "lg"}: {message?: string, size?: string}) => {
    return (
        <div className="d-flex ar-component-loading-container justify-content-center align-items-center bg-transparent flex-column">
            {message && <div className="font-16 mb-32">{message}</div>}
            {window.useGaiaDesign ?
                <span className={`ga-spinner ${"spinner-" + size }`}></span> :
                <span className="spinner spinner-secondary-grey d-block"></span>
            }
        </div>
    );
}